/**
 * @module app.cd
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/essette-api';
import { MemberService } from 'app/cd/services/member-service';
import { Toaster } from 'app/shared/lib/toaster';
import * as CD from 'app/cd/models/essette-api';

@autoinject()
export class AdditionalContactDetails extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable({ defaultBindingMode: bindingMode.toView })
    public member: CD.Member | null = null;

    protected maxTextLength: number = 4000;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly memberService: MemberService,
        private readonly toaster: Toaster,
        ...rest: any[]) {
        super(...rest);
    }


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    protected buildContactDetails(): CD.MemberContactPreference { // TODO: Change any to CD.MemberContactDetails
        const contactDetails: CD.MemberContactPreference = {
            member: {
                id: this.member?.id
            },
            summary: this.member?.contact?.preference?.summary || null
        }

        return contactDetails;
    }


    ////****************** Service Calls ********************************************////
    @apiCall
    protected async saveContactDetails(): Promise<void> {
        if(!this.member) { return; }

        try {
            this.state.beginSave();

            const response = await this.memberService.saveMemberContactDetails(this.buildContactDetails());
            this.toaster.standard.saved('cd:memberContact.$', response.isSuccessful);
        }
        catch(error) {
            this.toaster.standard.saved('cd:memberContact.$', false);
            throw error;
        }
        finally {
            this.state.endSave();
        }
    }
}
